/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { DistrictResponseDto } from './districtResponseDto';
import { ProvinceResponseDto } from './provinceResponseDto';
import { SubDistrictResponseDto } from './subDistrictResponseDto';

export interface BranchResponseTabletDto {
  id: string;
  branchName: string;
  name: string;
  imageUrl: string;
  address: string;
  province: ProvinceResponseDto;
  district: DistrictResponseDto;
  subDistrict: SubDistrictResponseDto;
  zipCode: string;
  email: string;
  type: BranchResponseTabletDto.TypeEnum;
}
// tslint:disable-next-line:no-namespace
export namespace BranchResponseTabletDto {
  export type TypeEnum = 'franchise' | 'wpn';
  export const TypeEnum = {
      Franchise: 'franchise' as TypeEnum,
      Wpn: 'wpn' as TypeEnum,
  };
}
